// Compatibility facade for @upn/con-entry-modals, which still expects the
// synchronous CommonJS shape that PDF.js removed in version 4.
const pdfjsPromise = import(
  /* webpackIgnore: true */ "/node_modules/pdfjs-dist/legacy/build/pdf.mjs?v=4.2.67"
).then(function (pdfjs) {
  pdfjs.GlobalWorkerOptions.workerSrc =
    "/node_modules/pdfjs-dist/legacy/build/pdf.worker.mjs?v=4.2.67";
  return pdfjs;
});

export const GlobalWorkerOptions = {};

export const getDocument = function (source) {
  return {
    promise: pdfjsPromise.then(function (pdfjs) {
      const documentSource =
        source instanceof Uint8Array
          ? { data: source }
          : typeof source === "string"
            ? { url: source }
            : source;

      return pdfjs.getDocument({
        ...documentSource,
        isEvalSupported: false,
        enableScripting: false,
      }).promise;
    }),
  };
};
